import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import DiplomasTable from '@app/components/shared/DiplomasTable'
import Notice from '@app/components/ui/notifications/Notice'
import Placeholder from '@app/components/ui/placeholders/Placeholder'
import Pills from '@app/components/ui/controls/Pills'
import Api from '@app/api'
import _ from 'lodash'
import SVG from 'react-inlinesvg'
import downloadWhite from '@icons/download/white'

const pills = (classes, current) => {
  return _.map(classes, ({ object }) => {
    let to = `/teachers/classes/${object.id}/diplomas`
    return { to, content: object.name, active: object.id === current.id }
  })
}

const Diplomas = ({ route, classes, group, event_id }) => {
  if (!group || !group.object) { return null }

  let diplomas = group.diplomas[event_id]

  return (
    <div className="page diplomas-page">
      <Pills items={ pills(classes, group.object) } route={route} />

      { _.size(group.students) === 0 ? (
          <Placeholder>
            { I18n.t('olympic_participations.trial_stats.placeholder') }
          </Placeholder>
        ) : (
          <DiplomasTable
            diplomas={diplomas}
            applicableFor="teacher"
            downloadArchiveLink={
              Api.teachers.diplomas({ class_id: group.object.id }).download.path
            }
          />
        )
      }

      {
        (!diplomas || !diplomas.object || !diplomas.object.length) ? null : (
          <Notice className="mb-0">
            <div className="diplomas-page__notice-inner">
              <p className="paragraph black">
                { I18n.t('awards.teacher_certificate') }
              </p>

              <a href={Api.teachers.diplomas({ class_id: group.object.id }).certificate.path}
                target="_blank"
                className="btn btn--icon-right">

               { I18n.t('awards.download') }
               <SVG src={downloadWhite} />
             </a>
            </div>
          </Notice>
        )
      }
    </div>
  )
}

Diplomas.propTypes = {
  group: PropTypes.object.isRequired,
  classes: PropTypes.array.isRequired,
  event_id: PropTypes.string.isRequired,
  route: PropTypes.object.isRequired
}

export default Diplomas
